/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetModifierGroup200ResponseModifiersInner } from './GetModifierGroup200ResponseModifiersInner';
import {
    GetModifierGroup200ResponseModifiersInnerFromJSON,
    GetModifierGroup200ResponseModifiersInnerFromJSONTyped,
    GetModifierGroup200ResponseModifiersInnerToJSON,
    GetModifierGroup200ResponseModifiersInnerToJSONTyped,
} from './GetModifierGroup200ResponseModifiersInner';

/**
 * 
 * @export
 * @interface GetModifierGroup200Response
 */
export interface GetModifierGroup200Response {
    /**
     * 
     * @type {string}
     * @memberof GetModifierGroup200Response
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetModifierGroup200Response
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetModifierGroup200Response
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetModifierGroup200Response
     */
    allowRepeat: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetModifierGroup200Response
     */
    max: number;
    /**
     * 
     * @type {number}
     * @memberof GetModifierGroup200Response
     */
    min: number;
    /**
     * 
     * @type {string}
     * @memberof GetModifierGroup200Response
     */
    organizationId: string;
    /**
     * 
     * @type {number}
     * @memberof GetModifierGroup200Response
     */
    position: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetModifierGroup200Response
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetModifierGroup200Response
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetModifierGroup200Response
     */
    externalId?: string | null;
    /**
     * 
     * @type {Array<GetModifierGroup200ResponseModifiersInner>}
     * @memberof GetModifierGroup200Response
     */
    modifiers: Array<GetModifierGroup200ResponseModifiersInner>;
}

/**
 * Check if a given object implements the GetModifierGroup200Response interface.
 */
export function instanceOfGetModifierGroup200Response(value: object): value is GetModifierGroup200Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('allowRepeat' in value) || value['allowRepeat'] === undefined) return false;
    if (!('max' in value) || value['max'] === undefined) return false;
    if (!('min' in value) || value['min'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    if (!('modifiers' in value) || value['modifiers'] === undefined) return false;
    return true;
}

export function GetModifierGroup200ResponseFromJSON(json: any): GetModifierGroup200Response {
    return GetModifierGroup200ResponseFromJSONTyped(json, false);
}

export function GetModifierGroup200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetModifierGroup200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'enabled': json['enabled'],
        'allowRepeat': json['allowRepeat'],
        'max': json['max'],
        'min': json['min'],
        'organizationId': json['organizationId'],
        'position': json['position'],
        'deleted': json['deleted'],
        'source': json['source'] == null ? undefined : json['source'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'modifiers': ((json['modifiers'] as Array<any>).map(GetModifierGroup200ResponseModifiersInnerFromJSON)),
    };
}

export function GetModifierGroup200ResponseToJSON(json: any): GetModifierGroup200Response {
    return GetModifierGroup200ResponseToJSONTyped(json, false);
}

export function GetModifierGroup200ResponseToJSONTyped(value?: GetModifierGroup200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'allowRepeat': value['allowRepeat'],
        'max': value['max'],
        'min': value['min'],
        'organizationId': value['organizationId'],
        'position': value['position'],
        'deleted': value['deleted'],
        'source': value['source'],
        'externalId': value['externalId'],
        'modifiers': ((value['modifiers'] as Array<any>).map(GetModifierGroup200ResponseModifiersInnerToJSON)),
    };
}

